import { useCallback, useRef } from 'react';

import { TrackingContextProvider, useTrackingContext } from '@context/TrackingContext';

export const useTrackingTiming = () => {
  const { getTimeFromInit } = useTrackingContext();
  const lastPageViewMs = useRef(0);
  TrackingContextProvider.useSubscribeToInitTimeReset(() => {
    lastPageViewMs.current = 0;
  });

  return useCallback((): number => {
    return getTimeFromInit() - lastPageViewMs.current;
  }, [getTimeFromInit]);
};
